import {t} from '../../../common/getTranslations';
import {requestContext} from '../../../common/requestContext';
import {twMerge} from '../../../common/twMerge';
import {showSimpleDialog} from '../../../dialog/simpleDialogHandler';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ContentTitleSectionProps} from './ContentTitleSectionProps';

export function ContentTitleSection({
  sectionTitle,
  href,
  isMobile,
  hasTitleBottomMargin,
  children,
  className,
  description,
  ...props
}: ContentTitleSectionProps) {
  return (
    <div {...props} className={twMerge('text-theme-solid-100', className)}>
      {sectionTitle && (
        <div
          className={twMerge(
            'flex justify-between px-15pxr pb-8pxr',
            !isMobile && 'px-32pxr pb-15pxr',
            hasTitleBottomMargin && 'mb-8pxr'
          )}
        >
          <div className="flex">
            <Text
              className={twMerge(
                'font-small1 flex-auto text-ellipsis break-all line-clamp-1',
                !isMobile && 'font-small1-bold'
              )}
            >
              {sectionTitle}
            </Text>
            {!!description && (
              <Icon
                type={IconType.ButtonHelpS}
                className="ml-4px inline cursor-pointer"
                onClick={e => {
                  e.stopPropagation();
                  showSimpleDialog({
                    isMobile: requestContext.requestInfo.display.isMobile,
                    title: '',
                    description,
                    okButton: {
                      text: t('common_confirm_button'),
                      type: 'label',
                      closeAfterClick: true,
                    },
                  });
                }}
              />
            )}
          </div>
          {isMobile && href && (
            <a href={href}>
              <Icon type={IconType.ButtonArrowRight} />
            </a>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
